<ng-content></ng-content><div #anchor></div>